import type { ReactElement } from 'react';
import { TailSpin } from 'react-loader-spinner';

interface LoaderProps {
  heading?: string;
}

export default function GlobalLoader({ heading }: LoaderProps): ReactElement {
  return (
    <div className="fixed inset-0 z-[150] flex flex-col items-center justify-center">
      {/* Glass backdrop */}
      <div 
        className="absolute inset-0 bg-white bg-opacity-20 backdrop-blur-sm"
        aria-hidden="true"
      />
      
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center">
        <TailSpin
          height="120"
          width="120"
          color="#00214D"
          ariaLabel="tail-spin-loading"
          radius="1"
          visible={true}
        />
        {heading && (
          <p className="mt-4 text-lg font-semibold text-primary">{heading}</p>
        )}
      </div>
    </div>
  );
}